import { render } from "./AppFabButton.vue?vue&type=template&id=85384938"
import script from "./AppFabButton.vue?vue&type=script&lang=js"
export * from "./AppFabButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__